import Vue from 'vue';
import Router from 'vue-router';
import PodcastsList from './views/PodcastsList.vue';
import Podcast from './views/Podcast.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'PodcastsList',
      component: PodcastsList,
    },
    {
      path: '/podcast/:id',
      name: 'Podcast',
      component: Podcast,
      props: true,
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
  ],
});
